import { render, staticRenderFns } from "./CalendarFile.vue?vue&type=template&id=0541c6c2&scoped=true&"
import script from "./CalendarFile.vue?vue&type=script&lang=js&"
export * from "./CalendarFile.vue?vue&type=script&lang=js&"
import style0 from "./CalendarFile.vue?vue&type=style&index=0&id=0541c6c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0541c6c2",
  null
  
)

export default component.exports